import ApplicationLayoutModel from "../models/applications/api/ApplicationLayoutModel";

interface RevenueApplicationIdentity {
    id: string;
    name?: string;
}

export const getRevenueGroupName = (
    layout: ApplicationLayoutModel | null | undefined,
    applicationId: string
): string => {
    const name = layout?.groups.find(group => group.appIds.includes(applicationId))?.name;
    return name && name !== "Other" ? name : "";
};

export const compareRevenueApplications = (
    layout: ApplicationLayoutModel | null | undefined,
    a: RevenueApplicationIdentity,
    b: RevenueApplicationIdentity
): number => {
    const groupA = getRevenueGroupName(layout, a.id);
    const groupB = getRevenueGroupName(layout, b.id);
    if (!!groupA !== !!groupB) return groupA ? -1 : 1;
    return groupA.toLowerCase().localeCompare(groupB.toLowerCase()) ||
        (a.name || a.id).toLowerCase().localeCompare((b.name || b.id).toLowerCase()) ||
        a.id.localeCompare(b.id);
};

export const getRevenueApplicationName = (
    organizationName: string,
    layout: ApplicationLayoutModel | null | undefined,
    applicationId: string,
    applicationName?: string
): string => {
    const groupName = getRevenueGroupName(layout, applicationId);
    return [organizationName, ...(groupName ? [groupName] : []), applicationName || applicationId].join(" - ");
};

export const getRevenueConfigFilename = (name: string): string =>
    `app-${name.replace(/[<>:"/\\|?*\x00-\x1f]/g, "_")}-config.json`;
